import { Fragment } from 'react';
import { Field, FormSection } from 'redux-form';

import { FieldWrapper } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/shared';
import RadioGroup from 'dashboard/components/FormControls/RadioGroup';
import { SelfieMatch } from 'dashboard/models/verification-template-version';

export const REQUIRE_SELFIE_MATCH_OPTIONS: {
  label: string;
  value: SelfieMatch;
  description?: string;
}[] = [
  {
    label: 'Left, center, and right poses',
    value: SelfieMatch.ProfileAndCenter,
  },
  {
    label: 'Center only pose',
    value: SelfieMatch.OnlyCenter,
  },
];

interface FormSectionSelfieMatchProps {
  name: string;
  editable: boolean;
}

const FormSectionSelfieMatch = ({ name, editable }: FormSectionSelfieMatchProps) => {
  return (
    <FormSection name={name} component={Fragment}>
      <FieldWrapper>
        <Field
          component={RadioGroup}
          name='require-selfie-match'
          id='require-selfie-match'
          data-test='form-selfie-config__selfie-match-field'
          disabled={!editable}
          radioLabelValues={REQUIRE_SELFIE_MATCH_OPTIONS}
          isCompact
        />
      </FieldWrapper>
    </FormSection>
  );
};

export default FormSectionSelfieMatch;
